<template>
	<GMapMap ref="gmapSingle" :center="center" :zoom="12" style="width: 100%; height: 600px" :options="options">
		<GMapInfoWindow :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen"
			@closeclick="infoWinOpen = false">
			<div v-html="infoContent"></div>
		</GMapInfoWindow>
		<GMapCluster>
			<GMapMarker v-for="(marker, index) in filteredMarkers"
				:position="{ lat: parseFloat(marker.lat), lng: parseFloat(marker.lng) }" :clickable="true"
				:icon="setIcon(marker.categorySlug)" :slug="marker.slug" :categorySlug="marker.categorySlug"
				:key="index" :title="marker.slug" @click="toggleInfoWindow(marker, index)">
			</GMapMarker>
		</GMapCluster>
	</GMapMap>
</template>

<script>
import axios from 'axios'

const url = document.body.getAttribute('data-base-url');

export default {
	data() {
		return {
			center: { lat: 40.735235, lng: -73.970827 },
			markers: [],
			infoContent: '',
			infoWindowPos: {
				lat: 0,
				lng: 0
			},
			infoWinOpen: false,
			currentMarkerIndex: null,
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: -40
				}
			},
		}
	},

	props: ['selectedCategory', 'selectedService', 'options'],

	mounted: function () {
		axios.get(url + 'locations/locations-map.json')
			.then((response) => {
				this.markers = response.data.markers;
				// Fit map to show all locations on initial load
				this.$nextTick(() => {
					this.fitMapToMarkers(true);
				});
			});

		this.addTitleToIframe();
	},

	updated() {
		this.addTitleToIframe();
	},

	computed: {
		filteredMarkers() {
			return this.markers.filter(marker => {
				const matchesCategory = this.selectedCategory === 'all' || marker?.categorySlug === this.selectedCategory;
				const matchesService = this.selectedService === 'all' || marker.relatedServices.some(service => service.slug === this.selectedService);
				return matchesCategory && matchesService;
			});
		}
	},

	methods: {
		setIcon: function (categorySlug) {
			if (categorySlug == 'healthcare-centers') {
				return '/images/active-health-center.svg';
			} else if (categorySlug == 'case-management') {
				return '/images/active-case-management.svg';
			} else if (categorySlug == 'pharmacy') {
				return '/images/pharmacy_pin-active.svg';
			} else {
				return '/images/pin.svg';
			}
		},

		toggleInfoWindow: function (marker, index) {
			// Close current info window first
			this.infoWinOpen = false;

			// Small timeout to ensure the previous window is closed
			setTimeout(() => {
				this.infoWindowPos = { lat: marker.lat, lng: marker.lng };

				axios.get(url + 'locations/info-window?slug=' + marker.slug)
					.then((response) => {
						return response.data;
					}).then((text) => {
						this.infoContent = text;
						this.currentMarkerIndex = index;
						this.infoWinOpen = true;

						// Center map on marker
						if (this.$refs.gmapSingle) {
							const map = this.$refs.gmapSingle.$mapObject;
							map.panTo({ lat: marker.lat, lng: marker.lng });
						}
					});
			}, 100);
		},

		fitMapToMarkers(useAllMarkers = false) {
			const markersToUse = useAllMarkers ? this.markers : this.filteredMarkers;
			if (markersToUse.length === 0 || !this.$refs.gmapSingle) return;

			const bounds = new google.maps.LatLngBounds();

			markersToUse.forEach(marker => {
				bounds.extend(new google.maps.LatLng(
					parseFloat(marker.lat),
					parseFloat(marker.lng)
				));
			});

			this.$refs.gmapSingle.$mapObject.fitBounds(bounds);

			// If there's only one marker, zoom out a bit
			if (markersToUse.length === 1) {
				setTimeout(() => {
					this.$refs.gmapSingle.$mapObject.setZoom(14);
				}, 100);
			}
		},

		addTitleToIframe() {
			setTimeout(() => {
				try {
					if (!this.$refs.gmapSingle) {
						return;
					}

					const mapEl = this.$refs.gmapSingle.$el;
					const iframe = mapEl.querySelector('iframe');

					if (!iframe) {
						return;
					}

					if (!iframe.hasAttribute('title') || iframe.getAttribute('title').trim() === '') {
						iframe.setAttribute('title', 'Location');
					}

					// Give the map's region landmark a unique accessible name
					// so it doesn't collide with the per-card maps below. Google
					// Maps sets a generic aria-label="Map", so we override it.
					const mapRegion = mapEl.querySelector('[role="region"][aria-label="Map"]');
					if (mapRegion) {
						mapRegion.setAttribute('aria-label', 'Map of all locations');
					}
				} catch (error) {
					console.error('Error in addTitleToIframe:', error);
				}
			}, 750);
		},
	},

	watch: {
		selectedCategory() {
			this.infoWinOpen = false;
			this.currentMarkerIndex = null;
			// Add small timeout to ensure markers are filtered first
			setTimeout(() => {
				this.fitMapToMarkers();
			}, 100);
		},
		selectedService() {
			this.infoWinOpen = false;
			this.currentMarkerIndex = null;
			// Add small timeout to ensure markers are filtered first
			setTimeout(() => {
				this.fitMapToMarkers();
			}, 100);
		}
	}
}
</script>
